import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Une clases de Tailwind resolviendo conflictos (la última gana).
 * Ej.: `cn('px-4', condition && 'px-6')` → `px-6`.
 *
 * Es el helper que usan todos los componentes de `src/components/ui`.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
